export const featureFlagsWarrantyAndService:Record<string, boolean> = {
  
}
